<template>
    <div>
      <Header></Header>
      <Nav></Nav>
      
      <div class="reconciliation">
        <div class="reconciliation-one">
          <div class="purHead">
            <el-tabs v-model="activeName" style="width: 100%;" @tab-click="handleClick">
              <el-tab-pane label="待付款" name="first">
                <Table :active="activeName"></Table>
              </el-tab-pane>
              <el-tab-pane label="已付款" name="second">
                <Table :active="activeName"></Table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </template>
  <script>
  import Header from '@/components/purchase/header/header'
  import Nav from '@/components/purchase/nav/nav'
  import Footer from '@/components/purchase/footer/footer'
  import Table from './table.vue'
  import './reconciliation.css'
  export default {
    components: {
      Header,
      Nav,
      Footer,
      Table
    },
    data() {
      return {
        activeName:"first",
      }
    },
    created() {
      // this.checkInfo()
    },
   
    mounted() {},
    methods: {
      handleClick(tab, event) {
        // console.log(this.activeName);
      },
      
    }
  }
  </script>
  <style lang="scss" scoped>
  .reconciliation {
    width: 100%;
    background-color: #f2f2f2;
    padding-top: 20px;
    .reconciliation-one {
      width: 1080px;
      height: 763px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        .purHead{
          width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            // border: 1px solid #ddd;
            border-radius: 6px;
            box-sizing: border-box;
            padding: 10px 30px 12px 30px;
            line-height: 16px;
          }
          
    }
  }
  </style>